import type { NotePriority } from "@/types";
import { NotePriorityValues } from "@/types";

export type SuspensionReasonOption = {
  value: string;
  label: string;
  code: string;
};

// Base suspension options available to users with manageSuspensions permission
export const BASE_SUSPENSION_REASON_OPTIONS: SuspensionReasonOption[] = [
  { value: "NON_PAYMENT_OF_DUES", label: "Non-Payment of Dues", code: "NPDU" },
  { value: "FAILURE_TO_MEET_ACCEPTABLE_PROGRESS", label: "Failure to Meet Acceptable Progress", code: "GPTP" }
];

// Restricted suspension options require manageSuspensionsRestricted permission (MS Admin only)
export const RESTRICTED_SUSPENSION_REASON_OPTIONS: SuspensionReasonOption[] = [
  { value: "ETHICS_VIOLATION", label: "Ethics Violation", code: "COEV" }
];

// All suspension reason options (for backward compatibility)
export const SUSPENSION_REASON_OPTIONS: SuspensionReasonOption[] = [
  ...BASE_SUSPENSION_REASON_OPTIONS,
  ...RESTRICTED_SUSPENSION_REASON_OPTIONS
];

export { NOTE_PRIORITY_OPTIONS } from "@/features/global/components/NotesTable/noteHelpers";

export type SuspensionFormValues = {
  suspensionReason: string;
  startDate: string;
  endDate: string;
  note: string;
  notePriority: NotePriority;
};

export const getDefaultSuspensionFormValues = (
  initialValues?: Partial<SuspensionFormValues>
): SuspensionFormValues => ({
  suspensionReason: initialValues?.suspensionReason ?? "",
  startDate: initialValues?.startDate ?? new Date().toISOString().split("T")[0],
  endDate: initialValues?.endDate ?? "",
  note: initialValues?.note ?? "",
  notePriority: initialValues?.notePriority ?? NotePriorityValues.NONE
});
